/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    fork, takeEvery, call, put, select,
} from 'redux-saga/effects';
import mbpLogger from 'mbp-logger';

import * as rewardPointsActions from './RewardPoints-Actions';
import { getPaymentInfo } from '../../../../Checkout/ducks/Common/Common-Selectors';
import { getFeatureFlags } from '../../App/App-Selectors';
import { checkJWT } from '../../../../Checkout/ducks/Global/Global-Operations';
import { getOrderId } from '../../../../Checkout/ducks/Global/Global-Selectors';
import { flagOffShowLoadingMessage, updateShowLoadingMessage } from '../../../../Checkout/ducks/Common/ducks/ShowLoadingMessage/ShowLoadingMessage-Actions';
import { getRewardPointsInfo } from './RewardPoints-Selectors';
import cartServiceClient from '../../../../../../apis/cart-service-apis/cartServiceClient';

const removeMaskForAccountNumber = (number) => {
    const strAccountNumber = number.toString();
    if (strAccountNumber.indexOf('-') >= 0) {
        return strAccountNumber.split('-').join('');
    }
    return strAccountNumber;
};

function* loadRewardsEligibility() {
    try {
        const paymentData =  yield select(getPaymentInfo);
        const featureFlags = yield select(getFeatureFlags);

        if (paymentData && paymentData.accountNumber && featureFlags['is-citi-rewards-enabled']) {
            yield put(rewardPointsActions.clearAllRewardsPoints());

            const jwtToken = yield call(checkJWT);
            const cartId = yield select(getOrderId);

            const responseRE = yield call(cartServiceClient.getRewardElegilibity, {
                wcEnv: {},
                jwtToken,
                cartId,
                creditCard: removeMaskForAccountNumber(paymentData.accountNumber),
                isCardTokenized: (paymentData?.isFromWallet),
                sourceApp: '', // This is not needed for PWA App
            });

            if (responseRE.status === 200) {
                yield put(rewardPointsActions.setRewardsEligibility(responseRE.data));
            }
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'loadRewardsEligibility',
            message: 'Failed finding eligibility',
        });
    }
}

function* loadRewardsEligibilityWatcher() {
    yield takeEvery(rewardPointsActions.loadRewardsEligibility().type, loadRewardsEligibility);
}

function* loadRewardsPoints() {
    try {
        const paymentData =  yield select(getPaymentInfo);
        const rewardPoints = yield select(getRewardPointsInfo);
        const featureFlags = yield select(getFeatureFlags);
        if (
            featureFlags['is-citi-rewards-enabled']
            && paymentData?.accountNumber
            && (rewardPoints?.eligibility === 'Y' || rewardPoints?.eligibility === 'E')
        ) {
            yield put(updateShowLoadingMessage());

            let rewardAction = 'ENABLE-REWARDS';
            if (rewardPoints?.eligibility === 'Y') {
                rewardAction = 'SHOW-REWARDS';
            }

            const jwtToken = yield call(checkJWT);
            const cartId = yield select(getOrderId);

            const responseRB = yield call(cartServiceClient.getRewardBalance, {
                wcEnv: {},
                jwtToken,
                cartId,
                creditCard: removeMaskForAccountNumber(paymentData.accountNumber),
                rewardAction,
                isCardTokenized: (paymentData?.isFromWallet),
                sourceApp: '', // This is not needed for PWA App
            });

            if (responseRB.status === 200) {
                let dataBalance = responseRB.data;

                // If the object come empty throw an error
                if (!dataBalance || Object.keys(dataBalance).length === 0) {
                    dataBalance = { error: true };
                    mbpLogger.logError({
                        responseBalance: responseRB,
                        appName: process.env.npm_package_name,
                        module: 'mbp-pwa-ui',
                        function: 'loadRewardsPoints',
                        message: 'Failed finding reward points balance',
                    });
                }

                yield put(rewardPointsActions.setRewardsPoints(dataBalance));
            }

            yield put(flagOffShowLoadingMessage());
        }
    } catch (ex) {
        mbpLogger.logError({
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            function: 'loadRewardsPoints',
            message: 'Failed finding reward points balance',
        });

        yield put(flagOffShowLoadingMessage());
    }
}

function* loadRewardsPointsWatcher() {
    yield takeEvery(rewardPointsActions.loadRewardsPoints().type, loadRewardsPoints);
}

const watchers = [
    fork(loadRewardsPointsWatcher),
    fork(loadRewardsEligibilityWatcher),
];

export {
    watchers,
};

export default {};
